import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RemoveDormatService {

  constructor(private http: HttpClient) {}

  /**
   * Remove Dormat - removes TB Inactive status (del_flag='Y')
   * @param url - API endpoint URL
   * @param params - Parameters including tax_year, cc_keys, status, del_flag
   * @returns Observable with response
   */
  removeDormat(url: string, params: any): Observable<any> {
    // Build URL encoded params for application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true }).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
}
